/**
 * **P3**
 *
 * @exports partnership_277
 * @category partnerships
 */
function factory({ window, document, thn }) {
    const partnership = {};
    /**
         * @memberOf module:partnership_277
         */
    partnership.getId = function getId() {
        return '277';
    };
    /**
         * @memberOf module:partnership_277
         */
    partnership.check = function check() {
        // Should return "true" if this module can handle the current page
        return !!window.location.hostname.match(/bookings/);
    };
    /**
         * @memberOf module:partnership_277
         */
    partnership.getHotelId = function getHotelId() {
        const hotelId = window.searchWidget?.availabilitySearch?.hotel || window.p3Hotels?.request?.hotel || thn.parseUrlParameter('hotel') || document.querySelector('[name=hotel]')?.value;
        const result = {
            partnership_hotel_id: hotelId,
        };
        return result;
    };
    /**
       * @memberOf module:partnership_277
       */
    partnership.boot = function boot() {
        thn.bus.on('thn:on_state_change', thn.siteCheck);
    };
    /**
           * @memberOf module:partnership_277
           */
    partnership.shutdown = function shutdown() {
        thn.bus.detach('thn:on_state_change', thn.siteCheck);
    };
    return partnership;
}

export { factory };
